import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IGetTramiteActividades, IGetUsuariosValidos } from '../../../../../shared/interfaces/database/tramite';
import { TramActividadService } from '../../../../../services/database/tramActividad.service';
import { Router } from '@angular/router';
import { LocalService, AccessRole, Utils, CustomTableComponent, ICustomTable, ButtonColumnType, DataColumnType, DATE_WITH_HOUR_FORMAT, FormGroupErrorMessageComponent, LoadingPanelService, IButtonColumn, IDataColumn } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SeguimientosHistorialComponent } from '../../../admin-actividad/tramite-historial/seguimientos-historial/seguimientos-historial.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-tramite-historial-actividad',
  standalone: true,
  imports: [CustomTableComponent, SeguimientosHistorialComponent, CommonModule, ReactiveFormsModule, FormsModule, DialogModule,
    FormGroupErrorMessageComponent, TranslateModule, ButtonModule, TooltipModule, DropdownModule
  ],
  templateUrl: './tramite-historial-actividad.component.html',
  styleUrls: ['./tramite-historial-actividad.component.scss']
})
export class TramiteHistorialActividadComponent implements OnInit {
  @Input() tramRegistroId !: number;
  @Input() enableReasignar : boolean = false;

  customTable !: ICustomTable;
  trans: any = {};
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  //reasignar modal
  displayReasignarModal = false;
  reasignarForm !: FormGroup;
  usuariosValidos: IGetUsuariosValidos[] = [];

  constructor(private readonly _tas: TramActividadService, public ls: LocalService, private readonly _t: TranslateService, private readonly _router: Router,
    private readonly _fb: FormBuilder, private readonly _ms: MessageService, private readonly _lps: LoadingPanelService
  ) {
    this.configureReasignarForm();
  }

  ngOnInit(): void {
    this.translate().then(() => this.configTable());
    this.getTramiteActividades();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      usuarioAsignado: this._t.get('common.usuarioAsignado'),
      estado: this._t.get('common.estado'),
      abrir: this._t.get('common.abrir'),
      fechaInicioPlanificada: this._t.get('msg.fechaInicioPlanificada'),
      fechaCierrePlanificada: this._t.get('msg.fechaCierrePlanificada'),
      fechaInicioReal: this._t.get('msg.fechaInicioReal'),
      fechaFinalizacionReal: this._t.get('msg.fechaFinalizacionReal'),
      actividades: this._t.get('common.actividades'),
      fir: this._t.get('common.fir'),
      ffr: this._t.get('common.ffr'),
      fip: this._t.get('common.fip'),
      fcp: this._t.get('common.fcp'),
      reasignarUsuario: this._t.get('msg.reasignarUsuario'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
    }));
  }

  private configTable() {
    let columns: (IDataColumn | IButtonColumn<IGetTramiteActividades>)[] = [
      {
        field: 'expand',
        header: '',
        class: 'p-button-info',
        width: '0.5rem',
        buttonType: ButtonColumnType.EXPANDED,
        onClick: (event: Event, data: IGetTramiteActividades) =>{}
      },
      {
        field: 'codificacion',
        header: this.trans.actividad,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        dataType: DataColumnType.TEXT
      },
      {
        field: 'orden',
        header: this.trans.orden,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        dataType: DataColumnType.NUMBER
      }
    ]

    if(this.enableReasignar){
      columns.push(
        {
          field: 'usuarioAsignadoNombre',
          header: this.trans.usuarioAsignado,
          label: this.trans.reasignarUsuario,
          icon: 'pi pi-file-edit',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          width: '0rem',
          buttonType: ButtonColumnType.TEXT,
          onClick: (event: Event, data: IGetTramiteActividades) => this.openReasignarModal(data),
          getDisabled: (data: IGetTramiteActividades) => {
            return !this.ls.hasRole(this.role.GESTION_TRAMITE) || data.estadoDescripcion !== 'PENDIENTE'
          },
          visible: {
            property: 'usuarioAsignadoCorreo',
            value: null
          },
        }
      )
    }else{
      columns.push(
        {
          field: 'usuarioAsignadoNombre',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          header: this.trans.usuarioAsignado,
          dataType: DataColumnType.TEXT,
        }
      )
    }

    columns = columns.concat([
      {
        field: 'estadoDescripcion',
        header: this.trans.estado,
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        dataType: DataColumnType.ESTADO_TAG
      },
      {
        field: 'fechaRealInicio',
        header: this.trans.fir,
        dataType: DataColumnType.DATE,
        format: DATE_WITH_HOUR_FORMAT,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        headerTooltip: {
          message: this.trans.fechaInicioReal,
          disabled: false
        }
      },
      {
        field: 'fechaRealCierre',
        header: this.trans.ffr,
        dataType: DataColumnType.DATE,
        format: DATE_WITH_HOUR_FORMAT,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        headerTooltip: {
          message: this.trans.fechaFinalizacionReal,
          disabled: false
        }
      },
      {
        field: 'fechaPlanificadaInicio',
        header: this.trans.fip,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        dataType: DataColumnType.DATE,
        format: DATE_WITH_HOUR_FORMAT,
        headerTooltip: {
          message: this.trans.fechaInicioPlanificada,
          disabled: false
        }
      },
      {
        field: 'fechaPlanificadaCierre',
        header: this.trans.fcp,
        class: 'font-13',
        columnmHeader: {
          class: 'text-left color-blue-2 font-13 font-bold',
        },
        format: DATE_WITH_HOUR_FORMAT,
        dataType: DataColumnType.DATE,
        headerTooltip: {
          message: this.trans.fechaCierrePlanificada,
          disabled: false
        }
      },
      {
        field: 'abrir',
        header: '',
        label: this.trans.abrir,
        icon: 'pi pi-folder-open',
        class: 'button-edit p-button-outlined pt-2 pb-2',
        width: '0rem',
        buttonType: ButtonColumnType.CUSTOM,
        onClick: (event: Event, data: IGetTramiteActividades) => this.onClick(data),
        disabled: !this.ls.hasRole(this.role.GESTION_TRAMITE),
        visible: {
          property: 'usuarioAsignadoCorreo',
          value: null
        }
      }
    ]);

    this.customTable = {
      columns: columns,
      settings: {
        table: {
          rows: 8
        }
      }
    } as ICustomTable;
  }

  onClick(data: IGetTramiteActividades) {
    this._router.navigate(['/configuracion/actividad/', this.tramRegistroId, data.id]);
  }

  getTramiteActividades() {
    if (!this.tramRegistroId) return;
    this._tas.getTramiteActividades(this.tramRegistroId).subscribe({
      next: (data: IGetTramiteActividades[]) => {
        this.customTableComponent.data = data;

        const lastRow = data[data.length - 1];
        if (lastRow && lastRow.estadoDescripcion === 'FINALIZADO') {
          this.customTableComponent.expandedRowKeys = { [lastRow.id]: true };
        }
      }
    });
  }

  getTramiteEstadoTagIcon(estado: string, usuarioAsignadoCorreo: string): string {
    return Utils.getTramiteEstadoTagIcon(estado, usuarioAsignadoCorreo);
  }

  getTramiteEstadoTagSeverity(estado: string, usuarioAsignadoCorreo: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    return Utils.getTramiteEstadoTagSeverity(estado, usuarioAsignadoCorreo);
  }

  //#region Reasignar
  private configureReasignarForm() {
    this.reasignarForm = this._fb.group({
      usuarioId: [null, [Validators.required]],
      actividadId: [null, [Validators.required]]
    });
  }

  getUsuariosValidosParaActividad(actividadId: number, usuarioId: number) {
    this._lps.show(true);
    this._tas.getUsuariosValidosParaActividad(actividadId).subscribe({
      next: (usuarios: IGetUsuariosValidos[]) => {
        this._lps.hide();
        this.usuariosValidos = usuarios;
        this.reasignarForm.get('usuarioId')?.setValue(usuarioId);
        this.reasignarForm.get('actividadId')?.setValue(actividadId);
      }
    });
  }

  openReasignarModal(data: IGetTramiteActividades) {
    this.resetReasignarForm();
    this.displayReasignarModal = true;
    this.getUsuariosValidosParaActividad(data.id, data.usuarioAsignadoId);
  }

  resetReasignarForm() {
    this.reasignarForm.reset();
    this.usuariosValidos = [];
  }

  onSubmitReasignarForm() {
    if (this.reasignarForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.reasignarForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.reasignarForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
      return;
    }

    this.reasignarActividad();
  }

  reasignarActividad() {
    this._lps.show(true);
    this._tas.reasignarActividad(this.reasignarForm.get('actividadId')?.value, this.reasignarForm.get('usuarioId')?.value).subscribe({
      next: (response: string) => {
        this._ms.add({ severity: 'success', summary: 'Exito', detail: response });
        this._lps.hide();
        this.getTramiteActividades();
        this.displayReasignarModal = false;
      }
    });
  }
  //#endregion
}
